import { Clock } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconClock12Line = createIcon(Clock, 12, "Line");
export const IconClock16Line = createIcon(Clock, 16, "Line");
export const IconClock20Line = createIcon(Clock, 20, "Line");
export const IconClock24Line = createIcon(Clock, 24, "Line");
export const IconClock32Line = createIcon(Clock, 32, "Line");
export const IconClock48Line = createIcon(Clock, 48, "Line");
export const IconClock64Line = createIcon(Clock, 64, "Line");
